import { Injectable } from '@angular/core';
import { Constants } from '../util/constants';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Agent } from '../models/agent.model';
import { Blend, BlendDetail } from '../models/blend.model';

@Injectable({
	providedIn: 'root'
})
export class BlendDataService {

	constructor(private http: HttpClient) { }

	/**
	 * this is the sample method to get data from server
	 * hardcoded URL need to put 
	 */
	getblends(loggedAgent:Agent, ismyblend:string): Observable<any> {
		var auth: string ='basic' + ' ' + btoa(loggedAgent.Email + ':' + loggedAgent.Password)
		var agentID = loggedAgent.AgentID
		const httpOptions = {
			headers: new HttpHeaders({ 
				 'authorization': auth
			})
		}
		return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/getblends/' + agentID + '/' + ismyblend,null , httpOptions).pipe()
	}


	getblenddetailsbyid(BlendID : string ,loggedAgent:Agent): Observable<any> {
		var auth: string ='basic' + ' ' + btoa(loggedAgent.Email + ':' + loggedAgent.Password)
		const httpOptions = {
			headers: new HttpHeaders({ 
				 'authorization': auth
			})
        }
		 return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/getblenddetailsbyid/' + BlendID,null , httpOptions).pipe()
	}

	saveBlend(Blend : Blend ,loggedAgent:Agent): Observable<any> {
		var auth: string ='basic' + ' ' + btoa(loggedAgent.Email + ':' + loggedAgent.Password)
		const httpOptions = {
			headers: new HttpHeaders({ 
				 'authorization': auth,
				 'Accept': 'application/json',
				 'Content-type': 'application/json'
			})
        }
		 return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/saveblend',JSON.stringify(Blend) , httpOptions).pipe()
	}
}